import Button from "../buttons/button/Button";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import { loginRedirect } from "../../utils/identity";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import styles from "./LogInButton.scss";

const LogInButton = () => {
  const { getTranslation, isMixAndMatch } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
    isMixAndMatch: boolean;
  };
  const buttonText = getTranslation("pdp_eap_log_in");

  const handleClick = () => {
    loginRedirect();
  };

  return (
    <Button
      type={BUTTON_TYPES.primary}
      handleClick={handleClick}
      ariaLabel={buttonText}
      additionalClasses={isMixAndMatch ? styles.fullWidthButton : styles.button}
    >
      <div>{buttonText}</div>
    </Button>
  );
};

export default LogInButton;
